document.addEventListener('DOMContentLoaded', () => {
  const selectors = [
      'h1',
      'h2',
      'h3',         
      '.button',
      'button',
      '.button--primary',
      '.button--secondary',
      '.shopify-payment-button__button--unbranded',
      '.btn'


    

    ];


  const buttons = document.querySelectorAll(selectors.join(','));

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.2 });

  buttons.forEach(btn => observer.observe(btn));
});

